export interface EntityProps {
    id: string;
    name?: string;
}

export class Entity {
    id: string;
    name?: string;

    constructor({ id, name }: { id: string; name?: string }) {
        if (!id) {
            throw Error('ID is required');
        }
        this.id = id;
        this.name = name;
    }

    update(data: Partial<this>): void {
        Object.assign(this, data);
    }

    toJSON(): object {
        return {
            ...this,
        };
    }
}
